import { supabase } from './supabase'

const DEFAULTS = {
  new_messages: true,
  new_likes: true,
  new_matches: true,
  reminders: true
}

/**
 * Загрузить настройки email-уведомлений. Если записи нет — создаём с дефолтами.
 */
export async function loadEmailNotifications(userId) {
  const { data, error } = await supabase
    .from('email_notifications')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle()

  if (error) {
    console.error('[settings] loadEmailNotifications', error)
    return DEFAULTS
  }
  if (data) {
    return {
      new_messages: data.new_messages ?? true,
      new_likes: data.new_likes ?? true,
      new_matches: data.new_matches ?? true,
      reminders: data.reminders ?? true
    }
  }
  const { data: inserted, error: insertErr } = await supabase
    .from('email_notifications')
    .insert({ user_id: userId, ...DEFAULTS })
    .select()
    .single()
  if (insertErr) {
    console.error('[settings] insert email_notifications', insertErr)
    return DEFAULTS
  }
  return {
    new_messages: inserted.new_messages ?? true,
    new_likes: inserted.new_likes ?? true,
    new_matches: inserted.new_matches ?? true,
    reminders: inserted.reminders ?? true
  }
}

/**
 * Сохранить настройки email-уведомлений (upsert по user_id).
 */
export async function saveEmailNotifications(userId, prefs) {
  const { error } = await supabase
    .from('email_notifications')
    .upsert(
      {
        user_id: userId,
        new_messages: prefs.new_messages,
        new_likes: prefs.new_likes,
        new_matches: prefs.new_matches,
        reminders: prefs.reminders
      },
      { onConflict: 'user_id' }
    )
  if (error) {
    console.error('[settings] saveEmailNotifications', error)
    return { error: error.message }
  }
  return { error: null }
}
